import { render } from "./PlayoutFilesTab.vue?vue&type=template&id=789bee1d"
import script from "./PlayoutFilesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutFilesTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayoutV2/PlayoutFilesTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "789bee1d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('789bee1d', __exports__)) {
    api.reload('789bee1d', __exports__)
  }
  
  module.hot.accept("./PlayoutFilesTab.vue?vue&type=template&id=789bee1d", () => {
    api.rerender('789bee1d', render)
  })

}


export default __exports__